import { useEffect } from "react"

import type { AxiosError, AxiosResponse } from "axios"
import isNumber from "lodash-es/isNumber"

import { axiosClient } from "$/http"

import { type TAppDispatcher, useAppDispatcher } from "@/3514/store/app"
import type { TEmptyCallback } from "@/shared/types/functions"
import { transformVersionToNumber } from "@/utils/common"

let lastCheckedVersion: string | null = null

function useProjectVersionMismatch(): void {
    const { setVersionMismatch }: TAppDispatcher = useAppDispatcher()

    useEffect((): TEmptyCallback => {
        const interceptor: number = axiosClient.interceptors.response.use(
            (response: AxiosResponse): AxiosResponse => {
                const serverVersion: string = response.headers["x-backend-version"]

                if (lastCheckedVersion === serverVersion) return response

                const staticVersion: string = JSAPP_CONF?.version
                const newlyTransformedStaticVersion: number | null = transformVersionToNumber(JSAPP_CONF?.version)

                let isMismatched: boolean = false

                if (isNumber(newlyTransformedStaticVersion)) {
                    const newlyTransformedServerVersion: number | null = transformVersionToNumber(serverVersion)

                    isMismatched = newlyTransformedServerVersion > newlyTransformedStaticVersion
                } else isMismatched = serverVersion && serverVersion > staticVersion

                if (isMismatched) {
                    lastCheckedVersion = serverVersion
                    setVersionMismatch(true)
                }

                return response
            },
            (error: AxiosError): Promise<never> => Promise.reject(error)
        )

        return (): void => void axiosClient.interceptors.response.eject(interceptor)
        // eslint-disable-next-line
    }, [])
}

export { useProjectVersionMismatch }
